var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlgorand(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120 50",
    style: {
      enableBackground: "new 0 0 120 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#A5A8B6;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000026844921967618061000000015878586240733452176_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.5,16.5v13.2h-2.7V16.5H39.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.5,20.8v8.9c0,2.8-2.2,4.5-4.8,4.5c-2.5,0-4.4-1.6-4.6-3.8h2.7c0.1,0.9,0.9,1.4,2,1.4c1,0,2-0.6,2-2v-1.1 c-0.7,0.4-1.6,0.7-2.5,0.7c-2.4,0-4.4-2-4.4-4.3c0-2.7,2-4.4,4.4-4.4c1,0,1.9,0.3,2.5,0.7v-0.5L50.5,20.8z M47.8,26.1v-2.2 c-0.6-0.8-1.3-1.1-2.1-1.1c-1.3,0-2.2,0.9-2.2,2.2c0,1,0.9,2.1,2.2,2.1C46.5,27.1,47.2,26.9,47.8,26.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61.2,25.1c0,2.7-2,4.7-4.7,4.7s-4.8-2-4.8-4.7s2-4.7,4.8-4.7C59.2,20.4,61.2,22.4,61.2,25.1z M58.6,25.1 c0-1.3-0.8-2.3-2.2-2.3c-1.3,0-2.2,1-2.2,2.3s0.8,2.3,2.2,2.3C57.7,27.5,58.6,26.5,58.6,25.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M77.8,20.8v8.9h-2.6v-0.5c-0.7,0.4-1.6,0.7-2.5,0.7c-2.4,0-4.4-2.1-4.4-4.6c0-2.6,2-4.7,4.4-4.7 c1,0,1.9,0.3,2.5,0.7v-0.5H77.8z M75.2,26.6v-2.7c-0.6-0.8-1.3-1-2.1-1c-1.3,0-2.3,1.1-2.3,2.4s0.9,2.4,2.3,2.4 C73.9,27.6,74.7,27.4,75.2,26.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M88.7,24.9v4.8h-2.6v-4.5c0-1.5-0.7-2.2-2-2.2c-0.7,0-1.4,0.4-2,1.1v5.6h-2.7v-8.9H82v0.7 c0.7-0.6,1.6-0.9,2.6-0.9C87,20.6,88.7,22.3,88.7,24.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M102.1,16.9h-0.7v1.6H101v-1.6h-0.7v-0.3h1.7L102.1,16.9L102.1,16.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104.4,18.4H104v-1.1l-0.5,0.8h-0.2l0,0l-0.5-0.8v1.1h-0.4v-1.9h0.3l0.7,1.2l0.7-1.2h0.3V18.4L104.4,18.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "lINT7W_00000029012298103143443410000018160013129510632120_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "35.6,29.7 32.8,29.7 31.1,23.1 27.3,29.7 24.2,29.7 30.1,19.4 29.1,15.9 21.2,29.7 18.1,29.7  28.2,12.2 30.9,12.2 32.1,16.5 34.8,16.5 33,19.8  "
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M99.4,16.5v13.2h-2.7v-0.5c-0.7,0.4-1.6,0.7-2.5,0.7c-2.4,0-4.4-2.1-4.4-4.7s2-4.6,4.4-4.6 c1,0,1.9,0.3,2.5,0.7v-4.8H99.4z M96.7,26.6v-2.7c-0.6-0.8-1.3-1-2.1-1c-1.4,0-2.3,1.1-2.3,2.4s0.9,2.4,2.3,2.4 C95.4,27.6,96.1,27.4,96.7,26.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M67.8,23.1c-0.6,0.1-2,0.1-2.8,1.3v5.4h-2.7V21H65v0.7c0.6-0.5,1.5-0.8,2.8-0.7"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000096745422287023299710000008425786254455116467_"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlgorand);
export default __webpack_public_path__ + "static/media/algorand.06aa633baae1d19ffeae8dae8895c88b.svg";
export { ForwardRef as ReactComponent };